import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { Location } from '@angular/common';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { select, Store } from '@ngrx/store';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';

import { ChatbotService } from '../../shareModule/component/chat/chatbot/chatbot.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { User } from 'src/app/shareModule/models/user.model';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { selectAllBizCategory } from 'src/app/shareModule/states/biz-category/biz-category.selector';
import { selectBizShopBanner } from 'src/app/shareModule/states/biz-shop-banner/biz-shop-banner.selector';
import { BehaviorSubject } from 'rxjs';
import { BizShopBanner } from 'src/app/shareModule/models/biz-shop-banner';
import { BizCardComponent } from '../biz-card/biz-card.component';

@Component({
  selector: 'app-advanced-settings',
  templateUrl: './advanced-settings.component.html',
  styleUrl: './advanced-settings.component.scss',
})
export class AdvancedSettingsComponent implements OnDestroy, OnInit {
  private destroy$ = new BehaviorSubject<void>(null);

  tab: number = 1;
  public userInfo: any = {};
  public modalRef: any = null;
  public imgUrl = environment.ImageUrl;
  public currentUrl: string = '/advanced-settings';
  public isBrowser = this.sharedService.isBrowser();
  public validSubscription: boolean = false;

  // Properties used in saveProfileInfo method


  public showBizPopup(data) {
    this.modalRef = this.modalService.open(BizCardComponent, {
      size: 'sm'
    })
    const ref: NgbModalRef = this.modalRef
    ref.componentInstance.bizCard = data;
  }

  selectedBizCategory: any = { id: '' };

  public selectBizCategory(index) {
    console.log("Selecting biz catgory", index)
    this.selectedBizCategory = index;
    this.getBizInfos()
  }

  public tabChange(index) {
    if (index == this.tab) return;
    this.tab = index;
    this.location.replaceState(`${this.currentUrl}?page=${index}`);
  }

  public bizCards = []

  getBizInfos() {
    this.auth.getBizInfos(this.selectedBizCategory.name).subscribe({
      next: (data: any) => {
        console.log({ data })
        this.bizCards = data.userIds
      },
      error: (err) => {
        console.error(err);
        this.toastr.error("Error something went wrong while fetching shopIds")
      }
    })
  }

  public categoryIconMap = {
    POPULAR: "star",
    FOOD: "utensils",
    SERVICES: "concierge-bell",
    HEALTH: "heartbeat",
    BEAUTY: "spa",
    RETAIL: "shopping-cart",
    CAR: "car",
    FINANCE: "dollar-sign",
  };

  public getCategoryList(): void {
    this.store.pipe(select(selectAllBizCategory)).subscribe((response: any) => {
      this.referCategories = structuredClone(response || []);
     // console.log("categoriest are ", this.referCategories)

      this.referCategories.map((c) => {
        c["slug"] = c.name.toLowerCase().replace(/ /g, "-");
      });
    });
  }

  constructor(
    private toastr: ToastrService,
    private location: Location,
    private auth: AuthServiceService,
    public roleService: RoleService,
    private customerService: CustomerService,
    public modalService: NgbModal,
    private http: HttpClient,
    public commonService: CommonService,
    private notificationService: MemberNotificationService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private chatbotService: ChatbotService,
    private local: LocalServiceService,
    private route: ActivatedRoute,
    public sharedService: SharedService,
    @Inject('WINDOW') private window
  ) {

    this.store.pipe(select(selectUser)).subscribe((user: User) => {
      this.userInfo = user;
      this.validSubscription = user?.subscription != null
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public referCategories = []

  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: "auto",
    pagination: false,
  };

  ngOnInit(): void {
    this.getCategoryList();
    this.getBizInfos();

    this.route.queryParams.subscribe((param) => {
      if (param['page']) {
        this.tabChange(parseInt(param['page']))
      }
    });

    this.store
      .pipe(select(selectBizShopBanner))
      .subscribe((response: Array<BizShopBanner>) => {
        this.get_all_product_banner_response = response;
        console.log("banners=", this.get_all_product_banner_response)
      });
  }

  public get_all_product_banner_response = []


  goBack() {
    this.commonService.goBack();
  }
}
